import { render, staticRenderFns } from "./FilterByItem.vue?vue&type=template&id=5682315a&scoped=true&"
import script from "./FilterByItem.vue?vue&type=script&lang=ts&"
export * from "./FilterByItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5682315a",
  null
  
)

export default component.exports